import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/KingJackpot.css";
import "../css/mainhome.css";
import clock1 from "../assets/icons/clock.svg";
import clock2 from "../assets/icons/clock2.svg";
import { LuGamepad2 } from "react-icons/lu";
import { AppContext } from "../context/AppContext";
import StarlineClosedModal from "../components/starlineclosedmodal";

export default function KingJackpotScreen() {
  const navigate = useNavigate();
  const [gameList, setGameList] = useState([]);
  const [closedGame, setClosedGame] = useState(null);
  const { user } = useContext(AppContext);

  useEffect(() => {
    const fetchJackpotGames = async () => {
      try {
        const registerId = localStorage.getItem("registerId");
        if (!registerId) return;

        const response = await apiClient.post("/jackpot-game-list", {
          registerId,
        });

        if (response?.data?.status && Array.isArray(response.data.info)) {
          const formatted = response.data.info.map((g) => ({
            gameId: g.gameId,
            gameName: g.gameName,
            time: g.gameName,
            result: g.result || "-",
            closed: !g.playStatus,
            statusText: g.playStatus
              ? "Betting is Running now"
              : "Betting is Closed for Today",
          }));
          setGameList(formatted);
        }
      } catch (e) {
        console.error("Error fetching jackpot games:", e);
      }
    };

    fetchJackpotGames();
  }, []);

  const handleGameClick = (game) => {
    if (!user?.accountStatus) {
      return;
    }
    if (game.closed) {
      setClosedGame(game);
      return;
    }
    navigate(`/jackpot/${game.gameId}`, {
      state: { gameName: game.gameName },
    });
  };

  const statItems = [
    { label: "Jodi", value: "10/0" }
  ];

  return (
    <div className="mainhome-screen-wrapper">
      <div className="kjd-wrap">
        <header className="kjd-header">
          <button
            className="kjd-back"
            onClick={() => navigate(-1)}
            aria-label="Back"
          >
            ‹
          </button>
          <div className="kjd-title">Jackpot Dashboard</div>
          <button
            className="kjd-history-top"
            onClick={() => navigate("/bids/jackpot-result-history")}
          >
            📋 View History
          </button>
        </header>

        <div className="kjd-subheaders">
          <span className="kjd-sub-label">Rates</span>
          <span className="kjd-sub-label">Jackpot Chart</span>
        </div>

        <div className="kjd-stats">
          {statItems.map((it, i) => (
            <div key={it.label} className="kjd-stat">
              <span className="lab">{it.label} :</span>
              <span className="val">{it.value}</span>
            </div>
          ))}
        </div>

        <div className="kjd-list-headers">
           <span className="kjd-main-title">Jackpot Games</span>
           <button 
             className="kjd-view-history"
             onClick={() => navigate("/bids/jackpot-result-history")}
            >
              View History
           </button>
        </div>

        <div className="jackpot-grid">
          {gameList.map((g) => {
            const running = !g.closed;
            return (
              <div
                key={g.gameId + g.time}
                className={`jackpot-card ${running ? "running" : "closed"}`}
                onClick={() => handleGameClick(g)}
                role="button"
              >
                <div className="kjd-card-header">
                  <span>{running ? "Betting is Running Now" : "Betting is Closed for Today"}</span>
                </div>

                <div className="kjd-card-body">
                  <div className="kjd-icon-wrap">
                    <img
                      src={running ? clock2 : clock1}
                      className="kjd-state-icon"
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                  <div className="kjd-card-info">
                    <div className="kjd-time-val">{g.time}</div>
                    <div className="kjd-result-val">{g.result || "***_*"}</div>
                  </div>
                </div>

                <div className="kjd-card-footer">
                  {running ? (
                    <button
                      className="kjd-play-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleGameClick(g);
                      }}
                    >
                      <LuGamepad2 className="gamepad-icon" />
                      Play Game
                    </button>
                  ) : (
                    <div className="kjd-closed-btn">
                      <span>CLOSED</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {closedGame && (
        <StarlineClosedModal
          game={closedGame}
          onClose={() => setClosedGame(null)}
        />
      )}
    </div>
  );
}